import type { ReactNode } from "react"

import InputError from "@/components/input-error"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

// IMP-518 (Compass): the one field rhythm every client-app form shares —
// 16px from the label block to its control, 32px between fields (the parent
// form provides that via `space-y-8`), with the sublabel tight under its
// label. Encoding the rhythm here keeps pages from re-deriving it with ad-hoc
// gap utilities.
export function FormField({
  label,
  htmlFor,
  sublabel,
  error,
  className,
  children,
}: {
  label: ReactNode
  htmlFor?: string
  // One line of supporting copy, tight under the label.
  sublabel?: ReactNode
  error?: string
  className?: string
  children: ReactNode
}) {
  return (
    <div className={className}>
      <div>
        <Label htmlFor={htmlFor}>{label}</Label>
        {sublabel && (
          <p className="text-muted-foreground mt-1 text-sm">{sublabel}</p>
        )}
      </div>
      <div className="mt-4">{children}</div>
      {error && <InputError message={error} className="mt-2" />}
    </div>
  )
}

// The gap between one field and the next. A plain wrapper rather than a bare
// class string so form pages state the rhythm by name.
export function FormFields({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return <div className={cn("space-y-8", className)}>{children}</div>
}
